import {useState,useEffect,useContext,memo} from 'react'
import axios from 'axios';
import Category from '../Category/Category';
import {getAll} from '../../Data/Utils';
import {buildItemsList} from '../../Data/GeneralFanction';
import './Categories.css'
import  '../../config.json'
import { LanguageContext } from '../../context';




function Categories({categories}) {
// const [ categoriesState,setCategoriesState]=useState([]);
// const [ categoryIdSelected,setCategoryIdSelected]=useState();

const { language } = useContext(LanguageContext);


// useEffect(()=>{
//   const getCtegories = async () => {
//       const webUrl=process.env.REACT_APP_APIURL;
//       const apiUrl=config.apiUrl;
//       const categoriesList=config.lists.categories.name; 
//       const selectedProps=config.lists.categories.selectProperties;
//       let { data: categoriesAll } = await getAll(`${webUrl}${apiUrl}?listName=${categoriesList}&selectedProps=${selectedProps}`);
//       var x=buildItemsList(categoriesAll);
//       setCategoriesState(x) ;

//   };
//   var config = require('../../config.json');

//     getCtegories();

// },[]);

  return (
    <div className='categories-container'>
    {
      categories.map((item,index)=>{
        return <Category key={index} category={item}/>
      })
    }
      
    </div>
    
  )
}

export default memo(Categories) 